"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("./index95.js");var t=a.arraySpeciesConstructor,c=function(e,r){return new(t(e))(r===0?0:r)};exports.arraySpeciesCreate=c;
